export default "__VITE_ASSET__Y2GJAu2x__"